'use client'

import { PageWrapper } from '@/components/common/PageWrapper'
import { useEffect } from 'react'
import { extractErrorMessage } from '@/utils'
import { IconWrapper } from '@/components/icons/IconWrapper'
import { AppUrls, IconIds } from '@/enums'
import { LinkWrapper } from '@/components/common/LinkWrapper'

export function PageError({ error, reset, location = '' }: { error: Error & { digest?: string }; reset: () => void; location?: string }) {
    useEffect(() => console.error(error), [error])
    return (
        <PageWrapper>
            <div className="mx-auto mt-10 flex flex-col items-center gap-4">
                <p className="text-lg font-semibold">
                    Sorry, something went <span className="text-orange-500">wrong</span> {location ? `(${location})` : ''}
                </p>
                <div className="flex w-full flex-col items-center gap-2 rounded-xl">
                    <pre className="max-h-96 w-full overflow-y-auto text-wrap rounded-xl border border-dashed border-orange-500 p-8 text-center text-xs text-orange-500">
                        {JSON.stringify(extractErrorMessage(error), null, 2)}
                    </pre>
                </div>
                <br />
                <div className="flex w-full flex-col items-center gap-2">
                    <button
                        onClick={() => reset()}
                        className="flex w-full items-center justify-center gap-2.5 rounded-xl border border-default p-3 font-semibold hover:bg-default/10 sm:py-2"
                    >
                        <p className="font-semibold">Reload page</p>
                        <IconWrapper id={IconIds.UPDATE_NOW} className="size-5" />
                    </button>

                    <p className="text-xs font-light">
                        Or reach out for help on telegram:
                        <LinkWrapper href={AppUrls.DEV_TELEGRAM} target="_blank" className="px-1 hover:underline">
                            @fberger_xyz
                        </LinkWrapper>
                    </p>
                </div>
            </div>
        </PageWrapper>
    )
}
